function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { ServerCollection } from '@server/serverLogger';
export class Logger {
    info(message, { action, actionModifier, appName, page, collection } = {}) {
        if (__CLIENT__) this.clientLogger.info({
            details: message,
            actionModifier,
            action,
            appName,
            page
        });
        if (__SERVER__) this.serverLogger.info(message, {
            collection: collection || ServerCollection.ServerLogs,
            operation: action,
            operationModifier: actionModifier,
            page
        });
    }
    warning(message, { action, actionModifier, appName, page, collection } = {}) {
        if (__CLIENT__) this.clientLogger.warning({
            details: message,
            actionModifier,
            action,
            appName,
            page
        });
        if (__SERVER__) this.serverLogger.warning(message, {
            collection: collection || ServerCollection.ServerLogs,
            operation: action,
            operationModifier: actionModifier,
            page
        });
    }
    debug(message, { action, actionModifier, appName, page, collection } = {}) {
        if (__CLIENT__) this.clientLogger.debug({
            details: message,
            actionModifier,
            action,
            appName,
            page
        });
        if (__SERVER__) this.serverLogger.debug(message, {
            collection: collection || ServerCollection.ServerLogs,
            operation: action,
            operationModifier: actionModifier,
            page
        });
    }
    error(message, { action, actionModifier, appName, error, page, collection } = {}) {
        if (__CLIENT__) this.clientLogger.error({
            details: message,
            actionModifier,
            action,
            appName,
            error,
            page
        });
        if (__SERVER__) this.serverLogger.error(message, {
            collection: collection || ServerCollection.ServerLogs,
            operation: action,
            operationModifier: actionModifier,
            page,
            error
        });
    }
    flush() {
        if (__CLIENT__) this.clientLogger.flush();
    }
    // eslint-disable-next-line no-useless-constructor
    constructor(clientLogger, serverLogger){
        _define_property(this, "clientLogger", void 0);
        _define_property(this, "serverLogger", void 0);
        this.clientLogger = clientLogger;
        this.serverLogger = serverLogger;
    }
}
